export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115')
];

export const server_loads = [];

export const dictionary = {
		"/": [24],
		"/(app)/(login)/auth": [96,[2,22]],
		"/(app)/(other)/change-organization": [104,[2]],
		"/(app)/(login)/cred-login": [97,[2,22]],
		"/(app)/(authorised)/(provider)/credentialing-agent": [30,[2,7]],
		"/(app)/(authorised)/(provider)/cvo-requests": [31,[2,7,9]],
		"/(app)/(authorised)/(provider)/cvo-requests/[path]": [32,[2,7,9]],
		"/(app)/(authorised)/(provider)/discover/license-verification": [33,[2,7]],
		"/(app)/(authorised)/(provider)/discover/provider-profile": [34,[2,7]],
		"/(app)/(authorised)/(provider)/discover/provider-profile/[id]": [35,[2,7]],
		"/(app)/(authorised)/(provider)/discover/search": [36,[2,7]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests": [27,[2,3,6]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests/[path]": [28,[2,3,6]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)": [25,[2,3,4,5]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)/[path]/[...rest]": [26,[2,3,4,5]],
		"/(app)/(login)/forgot-password": [98,[2,22]],
		"/(app)/(authorised)/(provider)/groups": [41,[2,7]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]": [37,[2,7]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview": [38,[2,7,10,11]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview/[tab]": [39,[2,7,10,11]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/payer/[id]": [40,[2,7,10]],
		"/(app)/(login)/login": [99,[2,23]],
		"/(app)/(login)/login/callback": [100,[2,23]],
		"/(other)/maintenance": [112],
		"/(app)/(authorised)/(provider)/my-network": [42,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests": [43,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/assigned": [44,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/cancellation-request": [45,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues": [52,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications": [53,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications/[tab=failedVerificationTab]": [54,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/monitoring-alerts": [55,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/npdb": [56,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/sanctions": [57,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring": [58,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/dashboard": [59,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/providers": [60,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review": [61,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/board": [62,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh": [46,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/import": [47,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/merge": [48,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/certificate": [63,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/cvo": [49,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/dea": [64,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/license": [65,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/medicaid": [66,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npdb": [67,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npi": [68,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile": [69,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile/[tab=profileImportListTab]": [70,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/sanctions": [71,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needsReview/[...any]": [50,[2,7,12,13]],
		"/(app)/(authorised)/(provider)/my-network/provider-license": [72,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/providerLicense/[...any]": [51,[2,7,12,14]],
		"/(app)/(authorised)/(provider)/my-network/providers": [73,[2,7,12]],
		"/(app)/(login)/new-password": [101,[2,22]],
		"/(other)/not-support": [113],
		"/(app)/(other)/org-picker": [105,[2]],
		"/(app)/(other)/print/[providerId=uuid]/[entity]/[id]": [107,[2]],
		"/(app)/(other)/print/[entityType]/[entityId=uuid]/[entity]/[id]": [106,[2]],
		"/(app)/(authorised)/(provider)/(backward-routes)/provider-detail/[...any]": [29,[2,7,8]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]": [74,[2,7,15]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge": [76,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]": [77,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/add": [78,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/review": [79,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge": [80,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]": [81,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/add": [82,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/resolve": [83,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/review": [84,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment": [85,[2,7,15,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment/[tab]": [86,[2,7,15,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/[...tab]": [75,[2,7,15]],
		"/(other)/report-template": [114],
		"/(other)/report-template/[template]": [115],
		"/(app)/(login)/reset-password": [102,[2,22]],
		"/(app)/(other)/review/alert/[id]": [110,[2]],
		"/(app)/(other)/review/[providerId=uuid]/[entity]/[id]": [109,[2]],
		"/(app)/(other)/review/[entityType]/[entityId=uuid]/[entity]/[id]": [108,[2]],
		"/(app)/(other)/select-providers/[entityId]": [111,[2]],
		"/(app)/(authorised)/settings": [88,[2,19]],
		"/(app)/(authorised)/settings/account": [89,[2,19,20]],
		"/(app)/(authorised)/settings/account/[tab]": [90,[2,19,20]],
		"/(app)/(authorised)/settings/audit-logs": [91,[2,19]],
		"/(app)/(authorised)/settings/coverage": [92,[2,19,21]],
		"/(app)/(authorised)/settings/coverage/[tab]": [93,[2,19,21]],
		"/(app)/(authorised)/settings/feature-preference": [94,[2,19]],
		"/(app)/(authorised)/settings/sources": [95,[2,19]],
		"/(app)/(login)/temp-token-login": [103,[2,22]],
		"/(app)/(authorised)/(provider)/verifiable-ai": [87,[2,7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';